import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=65301075&scoped=true&"
import script from "./UpgradeModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=65301075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65301075",
  null
  
)

export default component.exports